// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"8527f2e0","126":"ea6bfe95","171":"8addf8e2","378":"c9db3f4f"}[chunkId] + ".chunk.js";
};